export default "__VITE_ASSET__DQo_HiSG__"